import { SVGProps, Ref, forwardRef } from 'react';

export const BoltOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m11.585 15.999-.006-1.794H8.645c-1.698 0-2.764-.005-3.49-.112-.296-.044-.301-.054-.175-.325.31-.665.894-1.558 1.83-2.975l1.567-2.376c1.527-2.314 2.575-3.895 3.409-4.868.158-.185.367-.475.412-.21.165.97.206 2.456.214 4.667l.005 1.794h2.934c1.698 0 2.765.005 3.49.112.296.044.302.054.175.325-.31.665-.893 1.557-1.828 2.975l-1.568 2.376c-1.527 2.314-2.575 3.895-3.41 4.868-.158.184-.367.47-.412.21-.165-.97-.206-2.456-.213-4.667m-4.71-8.574L5.307 9.802c-1.803 2.732-2.705 4.098-2.139 5.15s2.203 1.053 5.477 1.053h1.14c.014 4.352.149 6.566 1.423 6.949 1.425.427 2.921-1.84 5.914-6.375l1.568-2.376c1.803-2.732 2.705-4.099 2.138-5.15C20.262 8 18.625 8 15.351 8h-1.14c-.014-4.352-.148-6.566-1.423-6.949-1.425-.428-2.92 1.84-5.913 6.375"
                fill="currentColor"
            />
        </g>
    </svg>
));
BoltOutlinedSize24Glyph.displayName = 'BoltOutlinedSize24Glyph';
